module.exports = __webpack_public_path__ + "static/media/YAB4.33407ef2.jpg";